export class Search
{
    field = document.querySelector('[data-s~="Search:field"]')
    timestamp = document.querySelector('[data-s~="Search:timestamp"]')
    token = document.querySelector('[data-s~="Search:token"]')
    container = document.querySelector('[data-s~="Search:container"]')
    phrases = document.querySelector('[data-s~="Search:phrases"]')
    template = document.querySelector('[data-s~="Search:template"]')
    buttonAll = document.querySelector('[data-s~="Search:buttonAll"]')
    templateError = document.querySelector('[data-s~="Search:template:error"]')

    clear()
    {
        this.phrases.innerHTML = null
    }

    decode(string)
    {
        const textarea = document.createElement("textarea")
        textarea.innerHTML = string
        let text = textarea.value
        textarea.remove()
        return text
    }

    pull()
    {
        this.clear()

        this.container.style.display = "flex"

        this.buttonAll.href = "/wyszukiwarka/"+this.decode(this.field.value)

        this.data.forEach(e => {
            let clone = this.template.content.cloneNode(true)

            clone
                .querySelector('[data-s~="Search:template:text:1"]')
                .textContent = this.decode(e.text[1])
            clone
                .querySelector('[data-s~="Search:template:text:2"]')
                .textContent = this.decode(e.text[2])
            clone
                .querySelector('[data-s~="Search:template:link:1:href"]')
                .href = this.decode(e.link[1].href)

            this.phrases.append(clone)
		})
    }

    error()
    {
        this.clear()

        this.container.style.display = "flex"

        this.buttonAll.href = "/wyszukiwarka/"+this.decode(this.field.value)

        let clone = this.templateError.content.cloneNode(true)

        clone
            .querySelector('[data-s~="Search:template:text:1"]')
            .textContent = this.decode(this.data.text[1])

            this.phrases.append(clone)
    }

    check()
    {
        let value = this.field.value
        let timestamp = this.timestamp.value
        let token = this.token.value

        fetch("/ajax/search.php", {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            body: JSON.stringify({
                phrase: value,
                timestamp: timestamp,
                token: token,
            })
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.data) {
                    this.data = data.data
                    this.pull()
                } else if (data.error) {
                    this.data = data.error
                    this.error()
                }
            })
    }

    watch()
    {
        this.field && this.field.addEventListener("keyup", () => {
            this.check()
        })
    }
}
